import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// /pay/<order> — where the "not paid yet" bell lands. A bell can only hold an app path, so this
// hands over to /api/pay/<order>, which mints a fresh Stripe session and redirects to it (or to
// the receipt when the order has been paid since).
const PayRedirect = () => {
  const { orderId } = useParams();
  useEffect(() => {
    window.location.replace(`/api/pay/${encodeURIComponent(orderId || '')}`);
  }, [orderId]);
  return null;
};

export default PayRedirect;
